import AutoComplete from "../../../material/autoComplete/AutoComplete";

const LaboratorySelect = ({ list, laboratory, onInputChange }) => {
  return (
    <div className="rounded-[6px] border-[#E2E2E4] border p-[9px_16px] mb-[10px] w-full">
      <h1 className="text-[18px] mb-[10px]">เลือกห้องปฏิบัติการที่สังกัด (ผู้ปฏิบัติการในห้องปฏิบัติการ)</h1>
      <AutoComplete
        id={laboratory.laboratory_id}
        label=""
        placeholder="ชื่อแลป"
        list={list}
        callBack={(res) => {
          onInputChange("laboratory_id", res["id"]);
        }}
      ></AutoComplete>
    </div>
  );
};

export default LaboratorySelect;
